
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        type: {
            type: String as PropType<'button' | 'submit'>,
            default: 'button'
        },
        color: {
            type: String as PropType<'gray' | 'royal-blue' | 'red'>,
            default: 'gray'
        },
        size: {
            type: String as PropType<'small' | 'medium' | 'big'>,
            default: 'medium'
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click'],
    setup(props, { emit }) {
        const onClick = (event: MouseEvent) => {
            if (props.disabled || props.loading) return
            emit('click', event)
        }
        
        return {
            onClick
        }
    }
})
